import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../../../service";
import { IErrorResponse, IRootState } from "../../../../../../types";
import {
    deletedEducationalSymbols,
    setEducationalSymbols,
    setEducationalSymbolsRestore,
    updateEducationalSymbols,
} from "./educationalSymbolsSlice";
import { IEducationalSymbolCreate, IEducationalSymbolPayload } from "../types";

const GetEducationalSymbols = createAsyncThunk(
    "get/educational/symbols",
    async (_, { dispatch, rejectWithValue, getState }) => {
        try {
            const response = await request.get("educational-symbols");
            const lang = getState() as IRootState;
            const defaultLanguage = lang.languages.defaultLanguage;
            dispatch(setEducationalSymbols({ data: response.data, defaultLanguage }));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "Something Wrong");
        }
    }
);

const SetEducationalSymbols = createAsyncThunk(
    "set/educational/symbols",
    async (data: IEducationalSymbolCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("educational-symbols", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;

            return rejectWithValue(typedError.response.data.message || "Something Wrong");
        }
    }
);
const EditEducationalSymbols = createAsyncThunk(
    "edit/educational/symbols",
    async (data: IEducationalSymbolPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/educational-symbols/${data.id}`, data);
            dispatch(updateEducationalSymbols(data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;

            return rejectWithValue(typedError.response.data.message || "Something Wrong");
        }
    }
);

const DeleteEducationalSymbols = createAsyncThunk(
    "delete/educational/symbols",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.delete(`/educational-symbols/${id}`);

            dispatch(deletedEducationalSymbols(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.error);
        }
    }
);

const GetDeleteEducationalSymbols = createAsyncThunk(
    "get/delete/educational/symbols",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get(`/educational-symbols/deleted-items`);

            dispatch(setEducationalSymbolsRestore(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "Something Wrong");
        }
    }
);
const RestoreEducationalSymbols = createAsyncThunk(
    "delete/educational/symbols",
    async (id: number, { rejectWithValue }) => {
        try {
            const response = await request.post(`/educational-symbols/restore/${id}`);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.error);
        }
    }
);

export {
    GetEducationalSymbols,
    SetEducationalSymbols,
    DeleteEducationalSymbols,
    EditEducationalSymbols,
    GetDeleteEducationalSymbols,
    RestoreEducationalSymbols,
};
